import {SafeUrl} from '@angular/platform-browser';

export abstract class StatusModel {
  img: SafeUrl;
  imgData: string;
  message: string;
  reasonId: number;
  organization: string;
  forwardingNumber: string;
  login: string;

  abstract getForwardingText(): string;
  abstract getForwardingDelay(): number;
}
